import { Languages } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TEACHING_LANGUAGES } from "@/lib/useCoachLanguages";

export const ALL_LANGUAGES = "all";

export const LanguageFilter = ({ value, onChange }) => (
  <div className="flex items-center gap-3">
    <Languages className="h-4 w-4 text-gold" strokeWidth={1.5} />
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="language-filter-trigger"
        aria-label="Filter coaches by teaching language"
        className="w-[220px] rounded-none border-cream-border bg-cream-light font-sans text-xs tracking-[0.15em] uppercase text-forest focus:ring-gold"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-none border-cream-border bg-cream-light">
        <SelectItem value={ALL_LANGUAGES} data-testid="language-option-all" className="font-sans text-sm text-forest">
          All Languages
        </SelectItem>
        {TEACHING_LANGUAGES.map((l) => (
          <SelectItem
            key={l}
            value={l}
            data-testid={`language-option-${l.toLowerCase().replace(/\s+/g, "-")}`}
            className="font-sans text-sm text-forest"
          >
            {l}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
